export default {
    namespaced: true,
    state: {
		params: {
			datebegin: null,
			dateend: null,
		},
        data: {
			datasets: {
				ds: []
			}
		},
    },
}